export const FILE_DOWNLOAD_STARTED = 'FILE_DOWNLOAD_STARTED';
export const FILE_DOWNLOAD_SUCCESS = 'FILE_DOWNLOAD_SUCCESS';
export const FILE_DOWNLOAD_FAILURE = 'FILE_DOWNLOAD_FAILURE';
export const DOWNLOAD_FILES_STARTED = 'DOWNLOAD_FILES_STARTED';
export const DOWNLOAD_FILES_SUCCESS = 'DOWNLOAD_FILES_SUCCESS';
export const DOWNLOAD_FILES_FAILURE = 'DOWNLOAD_FILES_FAILURE';
export const DEFINITIONS_FILES_STARTED = 'DEFINITIONS_FILES_STARTED';
export const DEFINITIONS_FILES_COMPLETED = 'DEFINITIONS_FILES_SUCCESS';
export const DOWNLOAD_STARTED = 'DOWNLOAD_STARTED';
export const DOWNLOAD_COMPLETED = 'DOWNLOAD_COMPLETED';
export const REIS_RESULT_CLEAR = "REIS_RESULT_CLEAR";
export const REIS_RESULT_STARTED = "REIS_RESULT_STARTED";
export const REIS_RESULT_SUCCESS = "REIS_RESULT_SUCCESS";
export const REIS_RESULT_FAILURE = "REIS_RESULT_FAILURE";
export const REIS_FILTER_SELECTION = "REIS_FILTER_SELECTION";
export const REIS_UPDATE_REIS_TEXT = "REIS_UPDATE_REIS_TEXT";
export const REIS_UPDATE_SORT = "REIS_UPDATE_SORT";
export const REIS_RESULT_UPDATE_STARTED = "REIS_RESULT_UPDATE_STARTED";